import { render } from "./GuidanceCenterHeader.vue?vue&type=template&id=1b2ac85b&scoped=true"
const script = {}

import "./GuidanceCenterHeader.vue?vue&type=style&index=0&id=1b2ac85b&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2ac85b"]])

export default __exports__